import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import SingleCompatibilityCard from "components/Actions/dialogs/components/SingleCompatibilityCard";

import { LABELS } from "../constants/labels";
import { getFeatureEntries } from "../functions";
import { CompatibilityContentProps } from "./types";

const CompatibilityContent = ({
    compatibilityData,
    features
}: CompatibilityContentProps) => {
    const { t } = useTranslation();

    const { compatible_devices_count, device_count } = compatibilityData;

    const featureEntries = getFeatureEntries(features);

    const activeFeatures = featureEntries.filter(
        ([_, value]) => value !== null
    );

    return (
        <div
            css={css({
                marginTop: "8px",

                "& > div:last-of-type": {
                    borderBottom: "none"
                }
            })}
        >
            <SingleCompatibilityCard
                title={t(
                    "Dialog##auto sync toggle##compatibility##compatible devices"
                )}
                value={compatible_devices_count}
            />

            <SingleCompatibilityCard
                title={t(
                    "Dialog##auto sync toggle##compatibility##selected devices"
                )}
                value={device_count}
            />

            {activeFeatures.map(([fileType, value]) => {
                const label = LABELS[fileType];

                return (
                    <SingleCompatibilityCard
                        key={fileType}
                        title={t(`General##${label}`)}
                        value={t(`Dialog##auto sync toggle##modes##${value}`)}
                    />
                );
            })}
        </div>
    );
};

export default CompatibilityContent;
